import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    height: '100%',
  },

  title: {
    fontFamily: '"Bebas Neue"',
    fontSize: theme.spacing(4.5),
  },

  cancelButton: {
    '&.MuiButton-root': {
      color: theme.palette.text.primary,
      border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,

      '&:hover': {
        border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,
        backgroundColor: theme.palette.error.light,
      },
    },
  },
}));
